import script from "./TopNav.component.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopNav.component.vue?vue&type=script&setup=true&lang=ts"

import "./TopNav.component.vue?vue&type=style&index=0&id=2f0469e0&lang=scss"

const __exports__ = script;

export default __exports__